import type { OrderStatus } from '@cuito/types';
import { apiClient } from '../../lib/apiClient';
import type { OrderDetailLine } from './orders';

/**
 * 订单码相关的两个端点（§10.2 商品码解析、§10.3 订单码在线回源）。
 *
 * `resolveOrderCode` 的四个字段**全部来自离线解码结果**（§20.2 的载荷头尾），
 * 因此它只在解码成功之后才可能被调用 —— 解码失败时连请求体都构造不出来
 * （附录 A26：它是**校验**，不是解码失败后的兜底）。
 */
export interface ResolvedOrderCode {
  order: {
    id: string;
    orderNo: string;
    shortCode: string;
    status: OrderStatus;
    totalAmount: string;
    createdAt: string;
    lines: Array<Omit<OrderDetailLine, 'done' | 'shortQty'> & { refundedQty?: number }>;
  };
  authoritative: boolean;
}

export function resolveOrderCode(input: {
  orderNo: string;
  shortCode: string;
  locationId: string;
  checksum: string;
}): Promise<ResolvedOrderCode> {
  return apiClient.post<ResolvedOrderCode>('/codes/resolve/order', input);
}

export interface ResolvedProductCode {
  found: boolean;
  product: { id: string; productCode: string; name: string; price?: string; imageUrl?: string | null; isAlbum?: boolean };
  atLocation: {
    locationId: string;
    shelf: { shelfId: string; code: string };
    shelfQuantity: number;
    availableQty: number;
    purchaseLimit: number | null;
    soldOut: boolean;
  } | null;
  reason?: 'NOT_IN_LOCATION' | 'SOLD_OUT' | 'LOCATION_INACTIVE';
  taobaoUrl: string | null;
}

export function resolveProductCode(
  code: string,
  body: { locationId: string } | { guestSessionId: string },
): Promise<ResolvedProductCode> {
  return apiClient.post<ResolvedProductCode>(`/codes/resolve/product/${encodeURIComponent(code)}`, body);
}
